<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 content-class="round-2xl")
  v-card
    v-card-title.px-4
      v-spacer
      .text-xl.font-bold.ml-10 {{ $t('delete_customer') }}
      v-spacer
      v-btn(icon @click="showDialog = false")
        v-icon mdi-close
    v-divider.mb-6
    
    .px-6.mb-16
      .text-lg.font-medium.mb-4 {{ $t('delete_confirmation', { text: $t('customer').toLowerCase() }) }}
      .text-md.mb-2 {{ $t('delete_confirmation_desc', { text: $t('customer').toLowerCase() }) }}
      .text-md {{ $t('click_confirm_to_proceed') }}
    v-divider

    v-card-actions.px-6.py-3
      v-spacer
      v-btn.button-md.primary400--text(@click="showDialog = false" text) {{ $t('cancel') }}
      v-btn.button-md(@click="deleteCustomer" :loading="isLoading" color="danger500" depressed dark) {{ $t('confirm') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['open', 'deleted', 'customers'],
  data: () => ({
    isLoading: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    deleteCustomer () {
      this.isLoading = true
      const ids = this.customers.map(item => item.id).join(',')
      this.$axios.delete(`/connect/${this.company.slug}/customers/${ids}`)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.customers_deleted_successfully')])
          this.$emit('deleted')
          this.showDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_delete_customer')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>